import { Network } from '@capacitor/network';
import { isNativePlatform } from './capacitorPlatform';

export async function getNetworkConnectionStatus() {
    if (isNativePlatform()) {
        const status = await Network.getStatus();
        return { connected: Boolean(status?.connected), connectionType: status?.connectionType || 'unknown' };
    }
    return { connected: navigator.onLine, connectionType: navigator.connection?.type || 'unknown' };
}

export async function getNetworkOnlineStatus() {
    if (!isNativePlatform()) {
        return navigator.onLine;
    }

    const status = await Network.getStatus();
    return Boolean(status?.connected);
}

export async function subscribeNetworkChanges(onStatusChange) {
    if (typeof onStatusChange !== 'function') {
        return () => {};
    }

    if (!isNativePlatform()) {
        const onOnline = () => onStatusChange(navigator.onLine, 'browser', { connected: navigator.onLine, connectionType: navigator.connection?.type || 'unknown' });
        const onOffline = () => onStatusChange(false, 'browser', { connected: false, connectionType: 'none' });
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);
        navigator.connection?.addEventListener?.('change', onOnline);

        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
            navigator.connection?.removeEventListener?.('change', onOnline);
        };
    }

    const listener = await Network.addListener('networkStatusChange', (status) => {
        onStatusChange(Boolean(status?.connected), 'capacitor', status);
    });

    return () => {
        listener.remove();
    };
}
